const interactiveMap = {
  en: {
    interactiveMapPage: {
      title: "Interactive Election Map",
      subtitle: "Click on regions to view detailed results",
      electionType: "Election Type",
      presidential: "Presidential",
      parliamentary: "Parliamentary",
      senatorial: "Senatorial",
      regional: "Regional",
      council: "Council",
      colourBy: "Colour by",
      coverage: "Reporting coverage",
      winner: "Leading party/candidate",
      auto: "Auto",
      byParty: "By party",
      byCandidate: "By candidate",
      refresh: "Refresh",
      shareTitle: "EReMS - Interactive Election Map",
      shareText: "🗺️ Explore election results across Cameroon's regions!",
      mapTitle: "Cameroon Electoral Map",
      descPresidential: "58 Divisions across 10 Regions",
      descParliamentary: "180 Constituencies across 10 Regions",
      descSenatorial: "10 Regions • 70 Seats",
      descRegional: "North-West & South-West Special Regions",
      descCouncil: "360 Councils across 10 Regions",
      national: "National",
      leadingCandidate: "Leading candidate",
      leadingParty: "Leading party",
      noResultsYet: "No results reported yet",
      coverageLegend: "Coverage Legend",
      divisionsAdm2: "Divisions (ADM2)",
      subdivisions: "Subdivisions",
      subdivision: "Subdivision",
      reported80: "80%+ reported",
      reported50: "50-80% reported",
      reported20: "20-50% reported",
      reportedLow: "<20% reported",
      clickViewSubdivisions: "Click to view subdivisions",
      clickToSelect: "Click to select",
      villageBoundaries: "Village boundaries",
      ofTotal: "{{reported}} of {{total}} {{unit}}",
      clickDrillDown: "Click to drill down",
      village: "Village",
      villagesSuffix: "{{name}} - Villages",
      councilsSuffix: "{{name}} - Councils",
      divisionsSuffix: "{{name}} - Divisions",
      regionTitle: "{{name}} Region",
      nationalOverview: "National Overview",
      villageView: "Village View",
      villageViewHint: "Selected subdivision is highlighted on the map",
      councilLabel: "Council",
      divisionLabel: "Division",
      regionLabel: "Region",
      backToCouncils: "Back to Councils",
      councilView: "Council View",
      councilViewHint: "Click on a council to view villages within it",
      totalSubdivisions: "Total Subdivisions",
      backToDivisions: "Back to Divisions",
      divisionView: "Division View",
      divisionViewHint: "Click on a division to view municipalities within it",
      unitsReported: "{{unit}} reported",
      unitsTotal: "total {{unit}}",
      totalDivisions: "Total Divisions",
      backToNational: "Back to National View",
      coverageLabel: "Coverage",
      percentComplete: "{{percent}}% complete",
      councilsDecided: "Councils Decided",
      validVotes: "Valid Votes",
      noResultsRegion: "No results reported yet for this region",
      noResultsHint: "Results will appear once submissions are approved",
      nationalCoverage: "National Coverage",
      projectedWinner: "Projected Winner",
      percentOfVotes: "{{percent}}% of votes",
      clickRegion: "Click on a region to view detailed results",
      allRegions: "All Regions",
      allRegionsDesc: "Quick view of all 10 regions",
      ofUnits: "of {{total}} {{unit}}",
      units: {
        divisions: "divisions",
        constituencies: "constituencies",
        seats: "seats",
        regions: "regions",
        councils: "councils",
        units: "units",
      },
    },
  },
  fr: {
    interactiveMapPage: {
      title: "Carte électorale interactive",
      subtitle: "Cliquez sur les régions pour consulter les résultats détaillés",
      electionType: "Type d'élection",
      presidential: "Présidentielle",
      parliamentary: "Législative",
      senatorial: "Sénatoriale",
      regional: "Régionale",
      council: "Municipale",
      colourBy: "Colorer par",
      coverage: "Couverture des rapports",
      winner: "Parti/candidat en tête",
      auto: "Auto",
      byParty: "Par parti",
      byCandidate: "Par candidat",
      refresh: "Actualiser",
      shareTitle: "EReMS - Carte électorale interactive",
      shareText: "🗺️ Explorez les résultats électoraux dans les régions du Cameroun !",
      mapTitle: "Carte électorale du Cameroun",
      descPresidential: "58 départements répartis dans 10 régions",
      descParliamentary: "180 circonscriptions réparties dans 10 régions",
      descSenatorial: "10 régions • 70 sièges",
      descRegional: "Régions spéciales du Nord-Ouest et du Sud-Ouest",
      descCouncil: "360 communes réparties dans 10 régions",
      national: "National",
      leadingCandidate: "Candidat en tête",
      leadingParty: "Parti en tête",
      noResultsYet: "Aucun résultat rapporté pour le moment",
      coverageLegend: "Légende de la couverture",
      divisionsAdm2: "Départements (ADM2)",
      subdivisions: "Arrondissements",
      subdivision: "Arrondissement",
      reported80: "80 %+ rapporté",
      reported50: "50-80 % rapporté",
      reported20: "20-50 % rapporté",
      reportedLow: "<20 % rapporté",
      clickViewSubdivisions: "Cliquez pour voir les arrondissements",
      clickToSelect: "Cliquez pour sélectionner",
      villageBoundaries: "Limites des villages",
      ofTotal: "{{reported}} sur {{total}} {{unit}}",
      clickDrillDown: "Cliquez pour explorer",
      village: "Village",
      villagesSuffix: "{{name}} - Villages",
      councilsSuffix: "{{name}} - Communes",
      divisionsSuffix: "{{name}} - Départements",
      regionTitle: "Région : {{name}}",
      nationalOverview: "Aperçu national",
      villageView: "Vue des villages",
      villageViewHint: "L'arrondissement sélectionné est mis en évidence sur la carte",
      councilLabel: "Commune",
      divisionLabel: "Département",
      regionLabel: "Région",
      backToCouncils: "Retour aux communes",
      councilView: "Vue des communes",
      councilViewHint: "Cliquez sur une commune pour voir les villages qu'elle contient",
      totalSubdivisions: "Total des arrondissements",
      backToDivisions: "Retour aux départements",
      divisionView: "Vue des départements",
      divisionViewHint: "Cliquez sur un département pour voir les communes qu'il contient",
      unitsReported: "{{unit}} ayant rapporté",
      unitsTotal: "{{unit}} au total",
      totalDivisions: "Total des départements",
      backToNational: "Retour à la vue nationale",
      coverageLabel: "Couverture",
      percentComplete: "{{percent}} % complété",
      councilsDecided: "Communes décidées",
      validVotes: "Suffrages valides",
      noResultsRegion: "Aucun résultat rapporté pour le moment pour cette région",
      noResultsHint: "Les résultats apparaîtront une fois les soumissions approuvées",
      nationalCoverage: "Couverture nationale",
      projectedWinner: "Vainqueur projeté",
      percentOfVotes: "{{percent}} % des voix",
      clickRegion: "Cliquez sur une région pour consulter les résultats détaillés",
      allRegions: "Toutes les régions",
      allRegionsDesc: "Aperçu rapide des 10 régions",
      ofUnits: "sur {{total}} {{unit}}",
      units: {
        divisions: "départements",
        constituencies: "circonscriptions",
        seats: "sièges",
        regions: "régions",
        councils: "communes",
        units: "unités",
      },
    },
  },
};

export default interactiveMap;
